<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
            <!-- //文本搜索内容 -->
            <div class="fun-panel fun-search-form-wrapper">
                <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="姓名">
                                <a-input v-model="queryParams.xm" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="身份证号码">
                                <a-input v-model="queryParams.zjhm" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="注册证书号码">
                                <a-input v-model="queryParams.zczbh" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="执业资格证书号">
                                <a-input v-model="queryParams.zyzgzsbh" placeholder="" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6"></a-col>
                        <a-col :span="24">
                            <span class="fun-search-form-buttons" :style="{ float: 'right', overflow: 'hidden' }">
                                <a-button type="primary" @click="loadData" style="margin-right: 8px">查询</a-button>
                                <a-button @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-anchor>

        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <vxe-toolbar
                    size="mini"
                    custom
                    :refresh="{
                        query: () => {
                            this.loadData();
                        }
                    }"
                ></vxe-toolbar>
                <!-- 表格 -->
                <vxe-table
                    ref="itemtable"
                    size="mini"
                    resizable
                    keep-source
                    auto-resize
                    row-id="id"
                    align="left"
                    :max-height="$FG_util.getTableHeightDirect(2)"
                    header-align="center"
                    highlight-hover-row
                    highlight-current-row
                    show-overflow="tooltip"
                    :data="tableData"
                    :edit-config="{
                        trigger: 'click',
                        mode: 'row',
                        showStatus: true,
                        showIcon: false
                    }"
                >
                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                    <vxe-table-column field="xm" title="姓名" width="120"> </vxe-table-column>
                    <vxe-table-column field="zczbh" title="注册证书号" width="150"> </vxe-table-column>
                    <vxe-table-column field="zzy" title="主专业" width="300"> </vxe-table-column>
                    <vxe-table-column field="fzy" title="辅专业" width="300" align="center"> </vxe-table-column>
                    <vxe-table-column field="ssdwmc" title="执业单位" min-width="150" align="center"></vxe-table-column>
                    <vxe-table-column field="qymc" title="属地" width="120" align="center"> </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    style="margin-top: 5px"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
    </div>
</template>

<script>
export default {
    name: "Zczxgcscx",
    components: {},
    data() {
        return {
            tableData: [], //表格数据
            queryParams: {},
            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 20,
                total: 0
            },
            // 排序
            sort: {
                field: "DJSJ",
                order: "desc"
            },
            tableDataLoading: false
        };
    },

    mounted() {
        this.loadData();
    },
    methods: {
        //点击页码
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //点击表头排序
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        //查询列表数据
        loadData(id) {
            if (!this.queryParams.xm && !this.queryParams.zjhm && !this.queryParams.zczbh && !this.queryParams.zyzgzsbh) {
                this.tableData = [];
            } else {
                // 如果没有指定选中记录则选中刷新前选中的记录
                if (!id) {
                    let row = this.$refs.itemtable.getCurrentRecord();
                    if (row) {
                        id = row.id;
                    }
                }
                this.tableDataLoading = true;
                this.$FG_http
                    .post(
                        "./api/jsaec/szxdwfwpt/zczxgcscx/list",
                        {
                            funid: "RY6010",
                            defaulttablename: "RY_JSRYXX",
                            pageNo: this.pageinfo.pageNo,
                            pageSize: this.pageinfo.pageSize,
                            queryParams: this.queryParams,
                            sort: this.sort
                        },
                        {
                            showSuccess: false
                        }
                    )
                    .then(({ success, data, errMsg }) => {
                        this.tableDataLoading = false;
                        if (success) {
                            this.tableData = data.data;
                            // 需要设置当前页，因为查询可能导致当前页发生变化
                            this.pageinfo.pageNo = data.pageinfo.pagenum;
                            this.pageinfo.total = data.pageinfo.maxrow;
                        } else {
                            // 数据加载失败清空表格
                            this.tableData = [];
                        }
                    })
                    .then(() => {
                        this.$nextTick(() => {
                            let row = null;
                            // 获取之前选择的记录
                            if (id) {
                                row = this.$refs.itemtable.getRowById(id);
                            }
                            // 如果之前没有选择记录且表格不为空则选择第一条记录
                            if (!row && this.tableData.length > 0) {
                                row = this.$refs.itemtable.getRowById(this.tableData[0].id);
                            }
                            if (row) {
                                // 设置当前记录
                                this.$refs.itemtable.setCurrentRow(row);
                            } else {
                                // 清空当前行
                                this.$refs.itemtable.clearCurrentRow();
                            }
                        });
                    });
            }
        },
        //重置文本内容
        reset() {
            this.queryParams = {};
        }
    }
};
</script>
